<template>
    <div>
        <p>
            <span v-b-tooltip.hover title="Exemple : -site:amazon.fr pour exclure amazon.fr des résultats, site:amazon.com OR site:gibson.com pur ne récupérer les résuultats que de amazon.com ou gibson.com">Filtres</span>
            <b-input v-model="filters"></b-input>
        </p>

        <p>
            <span>Code</span>
            <b-select :options="['ean', 'upc']" v-model="code"></b-select>
        </p>

        <b-button @click="search()">Rechercher</b-button>

        <div v-for="(result, idx) in results" :key="idx">
            <p>Recherche : {{result.query}}</p>
            <div>Type: {{ result.code }}</div>
            <div>Code : {{result.code_result}}</div>
            <div>Score : {{result.score}}%</div>
            <ul>
                <li v-for="(score, idx) in result.score_text" :key="idx">
                    {{score}}
                </li>
            </ul>
            <div v-show="false">
                <div v-for="(match, idx) in result.match" :key="idx">
                    {{match}}
                </div>
            </div>
            <div>Liste des {{result.code}}</div>
            <ul>
                <li v-for="(code, idx) in result.codes" :key="idx">
                    {{code.code}} - {{code.nb}} fois 
                </li>
            </ul>
            <b-button v-b-modal="'ean'+ uid + idx" variant="link" >Résultats</b-button>
            <b-modal :title="'Résultats pour ' + result.query" size="xl" ok-only :id="'ean'+ uid + idx">
                <b-card v-for="(r, idx) in result.result" :key="idx">
                    <b>Position:</b> {{r.position}}<br />
                    <b>Titre:</b> {{r.title}}<br />
                    <b>Lien:</b> {{r.link}}<br />
                    <b>Lien affiché:</b> {{r.displayed_link}}<br />
                    <b>Texte:</b> 
                    <div v-html="r.snippet_color"></div>
                </b-card>
            </b-modal>
        </div>

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
    </div>
</template>

<script>
	var clone = require("clone");

    import workers from "../../services/workers.js";
    import treatments from "../../services/treatments.js";
	import utils_treatments from "../../utils/treatment.js";
    import edit_tabulator from "../../components/edit_tabulator.vue";

    import moment from "moment";
	import * as json2csv from "json2csv";
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

    export default {
		components: {
			edit_tabulator,
            FadeLoader
		},
		data() {
			return {
                uid: this.$uuid.v4(),

                filters: "",
                results: [],
                code: "ean",
                codes_options: {
                    "ean": {
                        regex_color: /([^0-9]|^)([0-9]{13})([^0-9]|$)/gi,
                        regex: /( ?[^0-9 ]*){0,3}([^0-9]|^)[0-9]{13}([^0-9]|$)/gi
                    },
                    "upc": {
                        regex_color: /([^0-9]|^)([0-9]{12})([^0-9]|$)/gi,
                        regex: /( ?[^0-9 ]*){0,3}([^0-9]|^)[0-9]{12}([^0-9]|$)/gi
                    }
                },

                spinner: false
            }
        },
        props: {
            test_data: {
				default: () => []
            },
            column_brand: "",
            brand: "",
            column_name: "",
        },
        watch:
        {
        },
        methods: {
            async load(data)
            {
                this.filters = data.filters || "";
            },
            async save()
            {
                return {

                }
            },
            async search(filters)
            {
                this.spinner = true;

                var data = clone(this.test_data);
                var code = this.code;
                this.results = [];

                for (var i = 0; i < data.length; i++)
                {
                    if (data[i][this.column_brand] != this.brand)
                    {
                        data.splice(i, 1);
                        i--;
                    }
                }

                data = data.slice(0, 10);

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", "api");

                var request = {
                    column_result: "result",
                    column_error: "error",
                    unique: false,
                    uri: "https://serpapi.com/search",
                    qs: [
                        ""
                    ],
                    qs_params: {
                        api_key: "serpapi_key",
                        engine: "google",
                        q: '"' + this.code + "\" ${data['" + this.column_name + "']} " + this.filters,
                        num: 20
                    },
                    options_template: true
                }

                formData.append("parameters", JSON.stringify(request));

                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });
                data = data.data;       
                
                for (var i = 0; i < data.length; i++)
                {
                    console.log(data[i])
                    var codes = {};
                    var codes_first_pos = {};
                    data[i].result = JSON.parse(data[i].result);
                    data[i].query = data[i].result.search_information.query_displayed;
                    data[i].match = [];
                    data[i].code_result = "";
                    if (data[i].result && data[i].result.organic_results)
                    {
                        var organic_results = []
                        for (var j = 0; j < data[i].result.organic_results.length && j < 100; j++)
                        {
                            organic_results.push({
                                id: this.$uuid.v4(),
                                position: data[i].result.organic_results[j].position,
                                title: data[i].result.organic_results[j].title,
                                link: data[i].result.organic_results[j].link,
                                displayed_link: data[i].result.organic_results[j].displayed_link,
                                snippet: data[i].result.organic_results[j].snippet,
                                snippet_color: data[i].result.organic_results[j].snippet.replace(this.codes_options[code].regex_color, "$1<span style='color: red'>$2</span>$3")
                            });
                            var match = data[i].result.organic_results[j].snippet.match(this.codes_options[code].regex);
                            var match_result = [];
                            console.log(match)
                            if (match)
                            {
                                for (var k = 0; k < match.length; k++)
                                {
                                    if (match[k].toLowerCase().includes(this.code))
                                    {
                                        data[i].match.push(match[k]);
                                        var m = match[k].replace(/[^0-9]/gi, "");
                                        if (!match_result.includes(m))
                                        {
                                            if (codes[m])
                                                codes[m]++;
                                            else
                                            {
                                                codes_first_pos[m] = j;
                                                codes[m] = 1;
                                            }
                                            match_result.push(m);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    data[i].result = organic_results;
                    
                    data[i].code = code;
                    data[i].codes = [];
                    var keys = Object.keys(codes);
                    for (var j = 0; j < keys.length; j++)
                    {
                        data[i].codes.push({
                            code: keys[j],
                            nb: codes[keys[j]],
                            pos: codes_first_pos[keys[j]]
                        })
                    }
                    data[i].codes.sort((a,b) => b.nb - a.nb);
                    data[i].score = 0;
                    data[i].score_text = [];
                    if (data[i].codes.length > 0)
                    {
                        data[i].code_result = data[i].codes[0].code;
                        
                        if (data[i].codes[0].nb >= 5)
                        {
                            data[i].score += 2;
                            data[i].score_text.push("Apparaît dans au moins 5 résultats.");
                        }
                        else if (data[i].codes[0].nb >= 3)
                        {
                            data[i].score += 1;
                            data[i].score_text.push("Apparaît dans au moins 3 résultats.");
                        }
                        if (data[i].codes[0].pos <= 3)
                        {
                            data[i].score++;
                            data[i].score_text.push("Apparaît dans les 3 premiers résultats");
                        }
                        if (data[i].codes.length > 1 && data[i].codes[0].nb >= data[i].codes[1].nb * 2)
                        {
                            data[i].score++;
                            data[i].score_text.push("Apparaît au moins deux fois plus que le deuxième " + data[i].code + " récupéré");

                            var nb = 0;
                            for (var j = 1; j < data[i].codes.length; j++)
                            {
                                nb += data[i].codes[j].nb;
                            }
                            if (data[i].codes[0].nb >= nb)
                            {
                                data[i].score++;
                                data[i].score_text.push("Apparaît plus ou autant de fois que la somme des autres " + data[i].code + " récupérés");
                            }
                        }
                        if (data[i].codes.length == 1)
                        {
                            data[i].score++;
                            data[i].score_text.push("Seul résultat");
                        }
                    }
                    data[i].score = data[i].score / 5 * 100;
                    if (data[i].score == 100)
                        data[i].score = 95;
                }

                this.results = data;

                console.log(this.results)

                this.spinner = false;
            }
        },
		mounted: async function () {
        }
    }
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
</style>